// extracted by mini-css-extract-plugin
export default {"icon":"LoginPassword_icon__iSxHP","operateContainer":"LoginPassword_operateContainer__Q5v+w","contactAdmin":"LoginPassword_contactAdmin__3w+a1"};